import React from "react";
import { useHistory } from "react-router-dom";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import { format } from "date-fns";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Swal from "sweetalert2";

class PayOrders extends React.Component {
  constructor(props) {
    super(props);

    this.handleRegentePage = this.handleRegentePage.bind(this);
    this.handleOpenPago = this.handleOpenPago.bind(this);
    this.handleChangeStatusOrder = this.handleChangeStatusOrder.bind(this);
    this.handleReturnStatusOrder = this.handleReturnStatusOrder.bind(this);
    this.handleCreateLicense = this.handleCreateLicense.bind(this);
    this.handleChangeStatusBaja = this.handleChangeStatusBaja.bind(this);
    this.handleEstablecimientoPage = this.handleEstablecimientoPage.bind(this);
    this.handleOpenPago_E = this.handleOpenPago_E.bind(this);
    this.handleProductoPage = this.handleProductoPage.bind(this);
    this.handleOpenPago_P = this.handleOpenPago_P.bind(this);
    this.handleReposicion = this.handleReposicion.bind(this);
    this.handleConstanciasPage = this.handleConstanciasPage.bind(this);
    this.handleCertificadosPage = this.handleCertificadosPage.bind(this);
    this.handleOpenPago_C = this.handleOpenPago_C.bind(this);
    this.handleOpenPago_Cer = this.handleOpenPago_Cer.bind(this);
    this.handleCreateAnotacionMarginal =
      this.handleCreateAnotacionMarginal.bind(this);
    //this.handleOpenPago_Cer = this.handleOpenPago_Cer.bind(this);
    this.handleOpenPago_Pre = this.handleOpenPago_Pre.bind(this);

    this.state = {
      previa: false,
      previa_url: "",
      working: true,
      modalRegente: false,
      modalPago: false,
      toggle: false,
      paginaActual: 0,
      paginas: 0,
      registros: 0,
      paginaActual_e: 0,
      paginas_e: 0,
      registros_e: 0,
      paginaActual_p: 0,
      paginas_p: 0,
      registros_p: 0,
      paginaActual_cer: 0,
      paginas_cer: 0,
      registros_cer: 0,
      paginaActual_pre: 0,
      paginas_pre: 0,
      registros_pre: 0,
      ordenes: [],
      ordenes_est: [],
      ordenes_pro: [],
      ordenes_cons: [],
      ordenes_cer: [],
      ordenes_pre: [],
      regenteDocsCheck: [],
      allRc: false,
      orden: {
        id: "",
        folio: "",
        nombre_cliente: "",
        cantidad_num: "",
        estatus: "",
        nombre_servicio: "",
        accion: "",
      },
      activeTab: "1",
      collapse: [
        { id: 1, collapse: true },
        { id: 2, collapse: false },
        { id: 3, collapse: false },
      ],
      date: new Date().toLocaleDateString(),
      paginaActual_c: 0,
      paginas_c: 0,
      registros_c: 0,
      accionCombo: Api.loadCatalogue("cat_accion"),
      TramiteCombo: Api.loadCatalogue("cat_tramite"),
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
      tipo_establecimiento: Api.loadCatalogue("cat_tipo_establecimiento"),
      actividad_establecimiento: Api.loadCatalogue("cat_actividad"),
      cat_tipo_producto: Api.loadCatalogue("cat_tipo_producto"),
      cat_constancia_tipo: Api.loadCatalogue("cat_constancia_tipo"),
      nivelUsuario: localStorage.nivel_actual,
      buscar: {},
      buscarEst: {},
      buscarPro: {},
      buscarCon: {},
      buscarCer: {},
      buscarPre: {},
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({
      collapse: newArray,
    });
  }

  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    this.setRegentesPage(1);
    this.setEstablecimientosPage(1);
    this.setProductosPage(1);
    this.setConstanciasPage(1);
    this.setCertificadosPage(1);
    this.setPreCertificadosPage(1);

    /* BUSCADORES */
    /* Regentes*/
    let b_regente = {
      target: "#busquedaRegente",
      nombre: "busquedaRegente",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 2,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          input: {
            cols: 4,
            name: "nombre",
            type: "text",
            label: "Nombre",
          },
        },
        {
          select: {
            cols: 3,
            name: "solicitud",
            type: "text",
            label: "Solicitud",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 3,
            name: "tramite_id",
            label: "Tramite",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.TramiteCombo.forEach((s) => {
                if(s.id == 1 || s.id == 2 || s.id == 9){
                  me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`
                };
              });
            },
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                if(s.id == 1 || s.id == 3 || s.id == 8){
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                }
              });
            },
          },
        },
        {
          input: {
            cols: 2,
            name: "referencia",
            text: "date",
            label: "Referencia",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscareg",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscar: bregente.data() });
              this.setRegentesPage(1);
            },
          },
        },
      ],
    };

    let bregente = Api.form(b_regente);
    /* Termina buscador regentes */

    /* Buscador Esablecimientos */
    let b_establecimiento = {
      target: "#busquedaEstablecimiento",
      nombre: "busquedaEstablecimiento",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 2,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          input: {
            cols: 4,
            name: "nombre",
            type: "text",
            label: "Nombre",
          },
        },
        {
          select: {
            cols: 3,
            name: "solicitud",
            type: "text",
            label: "Solicitud",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 3,
            name: "tramite_id",
            label: "Tramite",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.TramiteCombo.forEach((s) => {
                if(s.id == 3 || s.id == 10 || s.id == 12 || s.id == 13 || s.id == 7){
                  me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`
                };
              });
            },
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                if(s.id == 1 || s.id == 3 || s.id == 8){
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                }
              });
            },
          },
        },
        {
          input: {
            cols: 2,
            name: "referencia",
            text: "date",
            label: "Referencia",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscareg",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarEst: bestablecimiento.data() });
              this.setEstablecimientosPage(1);
            },
          },
        },
      ],
    };
    let bestablecimiento = Api.form(b_establecimiento);
    /*  termina buscador establecimientos */

    /* Buscador productos */
    let b_producto = {
      target: "#busquedaProducto",
      nombre: "busquedaProducto",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 2,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          input: {
            cols: 4,
            name: "nombre",
            type: "text",
            label: "Nombre",
          },
        },
        {
          select: {
            cols: 3,
            name: "solicitud",
            type: "text",
            label: "Solicitud",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 3,
            name: "tramite_id",
            label: "Tramite",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.TramiteCombo.forEach((s) => {
                if(s.id == 4 || s.id == 8 || s.id == 11 || s.id == 14 || s.id == 15){
                  me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`
                };
              });
            },
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                if(s.id == 1 || s.id == 3 || s.id == 8){
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                }
              });
            },
          },
        },
        {
          input: {
            cols: 2,
            name: "referencia",
            text: "date",
            label: "Referencia",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscareg",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarPro: bproducto.data() });
              this.setProductosPage(1);
            },
          },
        },
      ],
    };
    let bproducto = Api.form(b_producto);
    /*  termina buscador productos */

    /* Buscador constancias */
    let b_constancia = {
      target: "#busquedaConstancia",
      nombre: "busquedaConstancia",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 6,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          input: {
            cols: 6,
            name: "nombre",
            type: "text",
            label: "Nombre",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                if(s.id == 1 || s.id == 3 || s.id == 8){
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                }
              });
            },
          },
        },
        {
          input: {
            cols: 2,
            name: "referencia",
            text: "date",
            label: "Referencia",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscareg",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarCon: bconstancia.data() });
              this.setConstanciasPage(1);
            },
          },
        },
      ],
    };
    let bconstancia = Api.form(b_constancia);

    /*  termina buscador constancias */

    /* Buscador certificados */
    let b_certificados = {
      target: "#busquedaCertificado",
      nombre: "busquedaCertificado",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 6,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          input: {
            cols: 6,
            name: "nombre",
            type: "text",
            label: "Nombre",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                if(s.id == 1 || s.id == 3 || s.id == 8){
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                }
              });
            },
          },
        },
        {
          input: {
            cols: 2,
            name: "referencia",
            text: "date",
            label: "Referencia",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscareg",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarCer: bcertificados.data() });
              this.setCertificadosPage(1);
            },
          },
        },
      ],
    };

    let bcertificados = Api.form(b_certificados);

    /*  termina buscador certificados */

    /* Buscador precertificados */
    let b_precertificados = {
      target: "#busquedaPreCertificado",
      nombre: "busquedaPreCertificado",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 6,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          input: {
            cols: 6,
            name: "nombre",
            type: "text",
            label: "Nombre",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                if(s.id == 1 || s.id == 3 || s.id == 8){
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                }
              });
            },
          },
        },
        {
          input: {
            cols: 2,
            name: "referencia",
            text: "date",
            label: "Referencia",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscareg",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarPre: bprecertificados.data() });
              this.setPreCertificadosPage(1);
            },
          },
        },
      ],
    };
    let bprecertificados = Api.form(b_precertificados);

    /*  termina buscador certificados */
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle) //

  //Funcion para cambiar de pagina en el grid de regente
  setRegentesPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getPayOrders?page=" + page + src).then((r) => {
      //Api.loading(true);
      this.setState({
        ordenes: r.data,
        paginas: r.last_page,
        registros: r.total,
        paginaActual: r.current_page,
        workingGrid: false,
      });
      //Api.loading(false);
    });
  }

  setEstablecimientosPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscarEst;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    Api.fetch("app/getOrdenesPagoEstablecimiento?page=" + page + src).then(
      (r) => {
        //Api.loading(true);
        this.setState({
          ordenes_est: r.data,
          paginas_e: r.last_page,
          paginaActual_e: r.current_page,
          registros_e: r.total,
          workingGrid: false,
        });
        // Api.loading(false);
      }
    );
  }

  setProductosPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscarPro;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    Api.fetch("app/getOrdenesPagoProducto?page=" + page + src).then((m) => {
      // Api.loading(true);
      this.setState({
        ordenes_pro: m.data,
        paginas_p: m.last_page,
        registros_p: m.total,
        paginaActual_p: m.current_page,
        workingGrid: false,
      });
      //Api.loading(false);
    });
  }

  setConstanciasPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscarCon;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    Api.fetch("app/getOrdenesPagoConstancias?page=" + page + src).then((m) => {
      //Api.loading(true);
      this.setState({
        ordenes_cons: m.data,
        paginas_c: m.last_page,
        registros_c: m.total,
        paginaActual_c: m.current_page,
        workingGrid: false,
      });
      //Api.loading(false);
    });
  }

  setCertificadosPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscarCer;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    Api.fetch("app/getOrdenesPagoCertificados?page=" + page + src).then((m) => {
      //Api.loading(true);
      this.setState({
        ordenes_cer: m.data,
        paginas_cer: m.last_page,
        registros_cer: m.total,
        paginaActual_cer: m.current_page,
        workingGrid: false,
      });
      //Api.loading(false);
    });
  }

  setPreCertificadosPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscarPre;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    Api.fetch("app/getOrdenesPagoPreCertificados?page=" + page + src).then(
      (m) => {
        //Api.loading(true);
        this.setState({
          ordenes_pre: m.data,
          paginas_pre: m.last_page,
          registros_pre: m.total,
          paginaActual_pre: m.current_page,
          workingGrid: false,
        });
        // Api.loading(false);
      }
    );
  }

  //Funcion auxiliar para cambiar de pagina en el grid de regente
  handleRegentePage(e) {
    this.setRegentesPage(e.target.value);
  }

  handleEstablecimientoPage(e) {
    this.setEstablecimientosPage(e.target.value);
  }

  handleProductoPage(e) {
    this.setProductosPage(e.target.value);
  }

  handleConstanciasPage(e) {
    this.setConstanciasPage(e.target.value);
  }

  handleCertificadosPage(e) {
    this.setPreCertificadosPage(e.target.value);
  }

  handleOrdenPago(e) {}

  //Funciones para controlar la validacion de pagos de regente
  handleOpenPago(e) {
    Api.fetch("app/getPayOrder", { id: e.target.id }, "POST").then((r) => {
      this.setState({
        orden: r,
      });
    });

    Swal.fire({
      title: "Validación de Pago",
      input: "text",
      inputLabel: "Número de referencia de la orden de pago:",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
      onOpen: () => {
        const input = Swal.getInput();
        input.oninput = () => {
          input.maxLength = 30;
        };
      },
      inputValidator: (numeroPago) => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!numeroPago) {
          return "Por favor ingresa el número de orden de pago.";
        } else {
          return undefined;
        }
      },
    }).then((resultado) => {
      if (resultado.value) {
        let orden = { ...this.state.orden };
        orden["referencia"] = resultado.value;
        this.setState({ orden: orden });

        if (
          (this.state.orden.accion === "1" ||
            this.state.orden.accion === "2") &&
          (this.state.orden.tramite_id === "1" ||
            this.state.orden.tramite_id === "2")
        ) {
          this.handleChangeStatusOrder(3, 1);
          this.handleCreateLicense();
        } else if (this.state.orden.accion === "2002") {
          //baja
          this.handleChangeStatusBaja(
            this.state.orden.solicitud_id,
            resultado.value,
            2,
            0
          ); //Baja licencia: 2, Baja regente: 0
        } else if (this.state.orden.accion === "3002") {
          this.handleChangeStatusOrder(3, 1); //Reposicion solo cambia el estatus de la orden a validada, no se realiza otra accion
          //this.handleReposicion();
        }
      }
    });
  }

  //Funciones para controlar la validacion de establecimientos
  handleOpenPago_E(e) {
    Api.loading(true);
    Api.fetch(
      "app/getPayOrderEstablecimiento",
      { id: e.target.id },
      "POST"
    ).then((r) => {
      this.setState({
        orden: r,
      });

      Swal.fire({
        title: "Validación de Pago",
        input: "text",
        inputLabel: "Número de referencia de la orden de pago:",
        showCancelButton: true,
        confirmButtonText: "Guardar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        onOpen: () => {
          const input = Swal.getInput();
          input.oninput = () => {
            input.maxLength = 30;
          };
        },
        inputValidator: (numeroPago) => {
          // Si el valor es válido, debes regresar undefined. Si no, una cadena
          if (!numeroPago) {
            return "Por favor ingresa el número de orden de pago.";
          } else {
            if (numeroPago.length > 30) {
              // Si el valor es mayor a 30, debes regresar undefined. Si no, una cadena
              return "Por favor ingresa una referencia menor a 30.";
            } else {
              return undefined;
            }
          }
        },
      }).then((resultado) => {
        if (resultado.value) {
          let orden = { ...this.state.orden };
          orden["referencia"] = resultado.value;
          this.setState({ orden: orden });
          //this.state.orden["referencia"] = resultado.value;

          if (this.state.orden.establecimiento_id === null) {
            //no tiene establecimiento, o sea es nuevo
            this.handleChangeStatusOrder(3, 2);
          } else {
            if (this.state.orden.accion === "3002") {
              this.handleChangeStatusOrder(3, 2); //Reposicion solo cambia el estatus de la orden a validada, no se realiza otra accion
            } else {
              this.handleChangeStatusOrder(7, 2);
            }
          }
        }
      });
    });
  }

  handleOpenPago_P(e) {
    Api.fetch("app/getPayOrderProducto", { id: e.target.id }, "POST").then(
      (r) => {
        this.setState({
          orden: r,
        });
      }
    );

    Swal.fire({
      title: "Validación de Pago",
      input: "text",
      inputLabel: "Número de referencia de la orden de pago:",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
      onOpen: () => {
        const input = Swal.getInput();
        input.oninput = () => {
          input.maxLength = 30;
        };
      },
      inputValidator: (numeroPago) => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!numeroPago) {
          return "Por favor ingresa el número de orden de pago.";
        } else {
          if (numeroPago.length > 30) {
            // Si el valor es mayor a 30, debes regresar undefined. Si no, una cadena
            return "Por favor ingresa una referencia menor a 30.";
          } else {
            return undefined;
          }
        }
      },
    }).then((resultado) => {
      if (resultado.value) {
        let orden = { ...this.state.orden };
        orden["referencia"] = resultado.value;
        this.setState({ orden: orden });
        //this.state.orden["referencia"] = resultado.value;
        this.handleChangeStatusOrder(3, 3);
        if (orden.tramite_id === "8") {
          this.handleCreateAnotacionMarginal();
        }
      }
    });
  }

  handleOpenPago_C(e) {
    Api.fetch("app/getPayOrderConstancia", { id: e.target.id }, "POST").then(
      (r) => {
        this.setState({
          orden: r,
        });
      }
    );

    Swal.fire({
      title: "Validación de Pago",
      input: "text",
      inputLabel: "Número de referencia de la orden de pago:",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
      onOpen: () => {
        const input = Swal.getInput();
        input.oninput = () => {
          input.maxLength = 30;
        };
      },
      inputValidator: (numeroPago) => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!numeroPago) {
          return "Por favor ingresa el número de orden de pago.";
        } else {
          if (numeroPago.length > 30) {
            // Si el valor es mayor a 30, debes regresar undefined. Si no, una cadena
            return "Por favor ingresa una referencia menor a 30.";
          } else {
            return undefined;
          }
        }
      },
    }).then((resultado) => {
      if (resultado.value) {
        let orden = { ...this.state.orden };
        orden["referencia"] = resultado.value;
        this.setState({ orden: orden });
        //this.state.orden["referencia"] = resultado.value;

        this.handleChangeStatusOrder(3, 4);
      }
    });
  }

  handleOpenPago_Cer(e) {
    Api.fetch("app/getPayOrderCertificado", { id: e.target.id }, "POST").then(
      (r) => {
        this.setState({
          orden: r,
        });
      }
    );

    Swal.fire({
      title: "Validación de Pago",
      input: "text",
      inputLabel: "Número de referencia de la orden de pago:",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
      onOpen: () => {
        const input = Swal.getInput();
        input.oninput = () => {
          input.maxLength = 30;
        };
      },
      inputValidator: (numeroPago) => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!numeroPago) {
          return "Por favor ingresa el número de orden de pago.";
        } else {
          if (numeroPago.length > 30) {
            // Si el valor es mayor a 30, debes regresar undefined. Si no, una cadena
            return "Por favor ingresa una referencia menor a 30.";
          } else {
            return undefined;
          }
        }
      },
    }).then((resultado) => {
      if (resultado.value) {
        let orden = { ...this.state.orden };
        orden["referencia"] = resultado.value;
        this.setState({ orden: orden });
        //this.state.orden["referencia"] = resultado.value;

        this.handleChangeStatusOrder(3, 5);
      }
    });
  }

  handleOpenPago_Pre(e) {
    Api.fetch(
      "app/getPayOrderforPreCertificado",
      { id: e.target.id },
      "POST"
    ).then((r) => {
      this.setState({
        orden: r,
      });
    });

    Swal.fire({
      title: "Validación de Pago",
      input: "text",
      inputLabel: "Número de referencia de la orden de pago:",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
      onOpen: () => {
        const input = Swal.getInput();
        input.oninput = () => {
          input.maxLength = 30;
        };
      },
      inputValidator: (numeroPago) => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!numeroPago) {
          return "Por favor ingresa el número de orden de pago.";
        } else {
          if (numeroPago.length > 30) {
            // Si el valor es mayor a 30, debes regresar undefined. Si no, una cadena
            return "Por favor ingresa una referencia menor a 30.";
          } else {
            return undefined;
          }
        }
      },
    }).then((resultado) => {
      if (resultado.value) {
        let orden = { ...this.state.orden };
        orden["referencia"] = resultado.value;
        this.setState({ orden: orden });

        this.handleChangeStatusOrder(3, 6);
      }
    });
  }

  //Funcion para postear el status
  handleChangeStatusOrder(e, type) {
    Api.loading(true);

    Api.fetch(
      "app/updateStatusOrder",
      {
        id: this.state.orden.id,
        status: e,
        referencia: this.state.orden.referencia,
      },
      "PUT"
    ).then((r) => {
      // No necesitamos refrescar, solo invocar la pagina actual del grid de establecimientos
      if (type === 1) {
        this.setRegentesPage(this.state.paginaActual);
      } else if (type === 2) {
        this.setEstablecimientosPage(this.state.paginaActual_e);
      } else if (type === 3) {
        this.setProductosPage(this.state.paginaActual_p);
      } else if (type === 4) {
        //.log(this.state.paginaActual_c);
        this.setConstanciasPage(this.state.paginaActual_c);
      } else if (type === 5) {
        this.setCertificadosPage(this.state.paginaActual_cer);
      } else if (type === 6) {
        this.setPreCertificadosPage(this.state.paginaActual_pre);
      }

      // Luego cerramos el modal
      Api.loading(false);
      this.setState({ modalRegente: false });

      Swal.fire({
        title: "Orden de pago actualizada",
        icon: "success",
        text: r.message,
        timer: 1500, //1.5 seconds
        showConfirmButton: false,
      });
    });
  }

  // Devuelve orden validada a "en espera" (DRYCIP)
  handleReturnStatusOrder(e, type) {
    const ordenId = e.target.id;
    if (!ordenId) {
      return;
    }

    Swal.fire({
      title: "Devolver a en espera",
      text: "Se limpiará la referencia de pago y la orden volverá a pendiente de validación.",
      input: "text",
      inputLabel: "Motivo (opcional)",
      showCancelButton: true,
      confirmButtonText: "Devolver",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#f0ad4e",
      reverseButtons: true,
    }).then((resultado) => {
      if (resultado.dismiss) {
        return;
      }

      Api.loading(true);
      Api.fetch(
        "app/returnStatusOrder",
        {
          id: ordenId,
          observacion: resultado.value || "",
        },
        "PUT"
      ).then((r) => {
        Api.loading(false);

        if (!r || !r.returned) {
          Swal.fire({
            title: "No se pudo devolver",
            icon: "error",
            text: (r && r.message) || "Ocurrió un error al retornar la orden",
          });
          return;
        }

        if (type === 1) {
          this.setRegentesPage(this.state.paginaActual);
        } else if (type === 2) {
          this.setEstablecimientosPage(this.state.paginaActual_e);
        } else if (type === 3) {
          this.setProductosPage(this.state.paginaActual_p);
        } else if (type === 4) {
          this.setConstanciasPage(this.state.paginaActual_c);
        } else if (type === 5) {
          this.setCertificadosPage(this.state.paginaActual_cer);
        } else if (type === 6) {
          this.setPreCertificadosPage(this.state.paginaActual_pre);
        }

        Swal.fire({
          title: "Orden retornada",
          icon: "success",
          text: r.message,
          timer: 1500,
          showConfirmButton: false,
        });
      });
    });
  }

  //creamos una nueva licencia
  handleCreateLicense() {
    //tomamos la informacion del regente y la solicitud
    const postData = this.state.orden;

    Api.fetch("app/createLicenseRegent", postData, "post").then((r) => {
      Swal.fire({
        title: "Se creó la licencia correctamente",
        icon: "success",
        text: r.message,
        timer: 1500, //1.5 seconds
        showConfirmButton: false,
      });
    });
  }

  //Enviamos un correo al usuario que ya puede ir por la reposicion de su licencia
  handleReposicion() {
    //tomamos la informacion del regente y la solicitud
    const postData = this.state.orden;

    Api.fetch("app/repoLicenseRegent", postData, "post").then((r) => {
      /*  Swal.fire({
          title: "Se creó la licencia correctamente",
          icon: "success",
          text: r.message,
          timer: 1500, //1.5 seconds
          showConfirmButton: false 
        }); */
    });
  }

  //funcion para dar de baja la licencia y el regente
  handleChangeStatusBaja(solicitud_id, referencia, estatus_lic, estatus_reg) {
    Api.loading(true);
    Api.fetch(
      "app/updateStatusLicenciaBaja",
      { solicitud_id, referencia, estatus_lic },
      "PUT"
    ).then((r) => {
      Api.notify(r.message);
      Api.loading(false);
      this.setRegentesPage(this.state.current_page);
    });
    /*
    Api.fetch(
      "app/updateStatusRegente",
      { solicitud_id, referencia, estatus_reg },
      "PUT"
    ).then((r) => {
      //Notificamos sin obstruir el UI, que todo bien.
      Api.notify(r.message);
      Api.loading(false);
      this.setRegentesPage(this.state.current_page);
    });
    */
  }

  handleCreateAnotacionMarginal() {
    const postData = this.state.orden;
    Api.fetch("app/updateAnotacionMarginalProducto", postData, "post").then(
      (r) => {
        /*       Swal.fire({
        title: "Se creó la anotación marginal correctamente",
        icon: "success",
        text: r.message,
        timer: 1500, //1.5 seconds
        showConfirmButton: false 
      }); */
      }
    );
  }

  //Terminamos con el control de regentes
  render() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "1" })}
                onClick={() => {
                  this.toggleTab("1");
                }}
              >
                <span className="d-sm-none">
                  REGENTES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  REGENTES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "2" })}
                onClick={() => {
                  this.toggleTab("2");
                }}
              >
                <span className="d-sm-none">
                  ESTABLECIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_e}
                  </span>
                </span>

                <span className="d-sm-block d-none">
                  ESTABLECIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_e}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "3" })}
                onClick={() => {
                  this.toggleTab("3");
                }}
              >
                <span className="d-sm-none">
                  PRODUCTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_p}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  PRODUCTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_p}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "4" })}
                onClick={() => {
                  this.toggleTab("4");
                }}
              >
                <span className="d-sm-none">
                  CONSTANCIAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_c}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CONSTANCIAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_c}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "5" })}
                onClick={() => {
                  this.toggleTab("5");
                }}
              >
                <span className="d-sm-none">
                  CERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_cer}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_cer}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "6" })}
                onClick={() => {
                  this.toggleTab("6");
                }}
              >
                <span className="d-sm-none">
                  PRECERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pre}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  PRECERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pre}
                  </span>
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaRegente"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Servicio</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Cantidad</th>
                      <th className="text-center">Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.ordenes && this.state.ordenes.length > 0 ? (
                      this.state.ordenes.map((ord) => (
                        <tr key={ord.id}>
                          <td className="text-center">{ord.folio}</td>
                          <td className="text-center">{ord.nombre_cliente}</td>
                          <td className="text-center">{ord.nombre_servicio}</td>
                          <td className="text-center">
                            {format(new Date(ord.fecha_orden), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">{ord.cantidad_num}</td>
                          <td className="text-center">{ord.estatus}</td>

                          {ord.estatus !== null &&
                          ord.estatus !== "Validada SGI" &&
                          ord.estatus !== "En espera de documentación" ? (
                            <td className="text-center">
                              <button
                                onClick={this.handleOpenPago}
                                id={ord.id}
                                className="btn bg-gradient-green"
                              >
                                <i
                                  id={ord.id}
                                  className="fas fa-money-check-alt"
                                ></i>
                              </button>
                            </td>
                          ) : ord.estatus !== "En espera de documentación" &&
                            ord.clave_referencia !== null ? (
                            <td className="text-center">
                              Referencia:{" "}
                              {ord.clave_referencia ? ord.clave_referencia : ""}
                              {ord.estatus === "Validada SGI" ? (
                                <button
                                  onClick={(ev) =>
                                    this.handleReturnStatusOrder(ev, 1)
                                  }
                                  id={ord.id}
                                  title="Devolver a en espera"
                                  className="btn btn-sm btn-warning ml-1"
                                >
                                  <i id={ord.id} className="fas fa-undo"></i>
                                </button>
                              ) : null}
                            </td>
                          ) : null}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setRegentesPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.setRegentesPage(this.state.paginaActual - 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.setRegentesPage(this.state.paginaActual + 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setRegentesPage(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleRegentePage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="2">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaEstablecimiento"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Servicio</th>
                      <th className="text-center">Razón social</th>
                      <th className="text-center">Tipo de establecimiento</th>
                      <th className="text-center">Actividad</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Cantidad</th>
                      <th className="text-center">Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.ordenes_est && this.state.ordenes_est.length > 0 ? (
                      this.state.ordenes_est.map((ord) => (
                        <tr key={ord.id}>
                          <td className="text-center">{ord.folio_orden}</td>
                          <td className="text-center">{ord.nombre_cliente}</td>
                          <td className="text-center">{ord.nombre_servicio}</td>
                          <td className="text-center">{ord.razon_social}</td>
                          <td className="text-center" title={ord.tipo}>
                            {ord.tipo.substr(0, 100)}...
                          </td>
                          <td className="text-center" title={ord.actividad}>
                            {ord.actividad.substr(0, 100)}...
                          </td>
                          <td className="text-center">
                            {format(new Date(ord.fecha_orden), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">{ord.cantidad_num}</td>
                          <td className="text-center">{ord.estatus}</td>
                          {ord.estatus !== null &&
                          ord.estatus !== "Validada SGI" &&
                          ord.estatus !== "Aceptada" &&
                          ord.estatus !== "En espera de documentación" ? (
                            <td className="text-center">
                              <button
                                onClick={this.handleOpenPago_E}
                                id={ord.id}
                                className="btn bg-gradient-green"
                              >
                                <i
                                  id={ord.id}
                                  className="fas fa-money-check-alt"
                                ></i>
                              </button>
                            </td>
                          ) : ord.estatus !== "En espera de documentación" &&
                            ord.clave_referencia !== null ? (
                            <td className="text-center">
                              Referencia: {ord.clave_referencia}
                              {ord.estatus === "Validada SGI" ? (
                                <button
                                  onClick={(ev) =>
                                    this.handleReturnStatusOrder(ev, 2)
                                  }
                                  id={ord.id}
                                  title="Devolver a en espera"
                                  className="btn btn-sm btn-warning ml-1"
                                >
                                  <i id={ord.id} className="fas fa-undo"></i>
                                </button>
                              ) : null}
                            </td>
                          ) : (
                            <td></td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          alignt="center"
                          style={{ textAlign: "center" }}
                          colSpan="10"
                        >
                          No hay datos
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setEstablecimientosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_e - 1 > 0) {
                            this.setEstablecimientosPage(
                              this.state.paginaActual_e - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_e} de {this.state.paginas_e}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_e >=
                            this.state.paginaActual_e + 1
                          ) {
                            this.setEstablecimientosPage(
                              this.state.paginaActual_e + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setEstablecimientosPage(this.state.paginas_e);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setEstablecimientosPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_e}
                      value={this.state.paginaActual_e}
                    />
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="3">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaProducto"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Servicio</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Cantidad</th>
                      <th className="text-center">Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.ordenes_pro.length > 0 ? (
                      this.state.ordenes_pro.map((ord) => (
                        <tr key={ord.id}>
                          <td className="text-center">{ord.folio_orden}</td>
                          <td className="text-center">{ord.nombre_cliente}</td>
                          <td className="text-center">{ord.nombre_servicio}</td>
                          <td className="text-center">
                            {format(new Date(ord.fecha_orden), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">{ord.cantidad_num}</td>
                          <td className="text-center">{ord.estatus}</td>

                          {ord.estatus !== null &&
                          ord.estatus !== "Validada SGI" &&
                          ord.estatus !== "En espera de documentación" &&
                          ord.estatus !== "En espera SINAIP" ? (
                            <td className="text-center">
                              <button
                                onClick={this.handleOpenPago_P}
                                id={ord.id}
                                className="btn bg-gradient-green"
                              >
                                <i
                                  id={ord.id}
                                  className="fas fa-money-check-alt"
                                ></i>
                              </button>
                            </td>
                          ) : (
                            <td className="text-center">
                              Referencia: {ord.clave_referencia}
                              {ord.estatus === "Validada SGI" ? (
                                <button
                                  onClick={(ev) =>
                                    this.handleReturnStatusOrder(ev, 3)
                                  }
                                  id={ord.id}
                                  title="Devolver a en espera"
                                  className="btn btn-sm btn-warning ml-1"
                                >
                                  <i id={ord.id} className="fas fa-undo"></i>
                                </button>
                              ) : null}
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setProductosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_p - 1 > 0) {
                            this.setProductosPage(
                              this.state.paginaActual_p - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_p} de {this.state.paginas_p}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_p >=
                            this.state.paginaActual_p + 1
                          ) {
                            this.setProductosPage(
                              this.state.paginaActual_p + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setProductosPage(this.state.paginas_p);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setProductosPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_p}
                      value={this.state.paginaActual_p}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="4">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaConstancia"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Servicio</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Cantidad</th>
                      <th className="text-center">Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.ordenes_cons.length > 0 ? (
                      this.state.ordenes_cons.map((ord) => (
                        <tr key={ord.id}>
                          <td className="text-center">{ord.folio_orden}</td>
                          <td className="text-center">{ord.nombre_cliente}</td>
                          <td className="text-center">{ord.nombre_servicio}</td>
                          <td className="text-center">
                            {format(new Date(ord.fecha_orden), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">{ord.cantidad_num}</td>
                          <td className="text-center">{ord.estatus}</td>

                          {ord.estatus !== null &&
                          ord.estatus !== "Validada SGI" &&
                          ord.estatus !== "En espera de documentación" ? (
                            <td className="text-center">
                              <button
                                onClick={this.handleOpenPago_C}
                                id={ord.id}
                                className="btn bg-gradient-green"
                              >
                                <i
                                  id={ord.id}
                                  className="fas fa-money-check-alt"
                                ></i>
                              </button>
                            </td>
                          ) : (
                            <td className="text-center">
                              Referencia: {ord.clave_referencia}
                              {ord.estatus === "Validada SGI" ? (
                                <button
                                  onClick={(ev) =>
                                    this.handleReturnStatusOrder(ev, 4)
                                  }
                                  id={ord.id}
                                  title="Devolver a en espera"
                                  className="btn btn-sm btn-warning ml-1"
                                >
                                  <i id={ord.id} className="fas fa-undo"></i>
                                </button>
                              ) : null}
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setConstanciasPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_c - 1 > 0) {
                            this.setConstanciasPage(
                              this.state.paginaActual_c - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_c} de {this.state.paginas_c}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_c >=
                            this.state.paginaActual_c + 1
                          ) {
                            this.setConstanciasPage(
                              this.state.paginaActual_c + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setConstanciasPage(this.state.paginas_c);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setConstanciasPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_c}
                      value={this.state.paginaActual_c}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="5">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaCertificado"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Servicio</th>
                      <th className="text-center">Tipo Certificado</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Cantidad</th>
                      <th className="text-center">Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.ordenes_cer.length > 0 ? (
                      this.state.ordenes_cer.map((ord) => (
                        <tr key={ord.id}>
                          <td className="text-center">{ord.folio_orden}</td>
                          <td className="text-center">{ord.nombre_cliente}</td>
                          <td className="text-center">{ord.nombre_servicio}</td>
                          <td className="text-center">
                            {ord.tipo_certificado}
                          </td>
                          <td className="text-center">
                            {format(new Date(ord.fecha_orden), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">{ord.cantidad_num}</td>
                          <td className="text-center">{ord.estatus}</td>

                          {ord.estatus !== null &&
                          ord.estatus !== "Validada SGI" &&
                          ord.estatus !== "En espera de documentación" ? (
                            <td className="text-center">
                              <button
                                onClick={this.handleOpenPago_Cer}
                                id={ord.id}
                                className="btn bg-gradient-green"
                              >
                                <i
                                  id={ord.id}
                                  className="fas fa-money-check-alt"
                                ></i>
                              </button>
                            </td>
                          ) : (
                            <td className="text-center">
                              Referencia: {ord.clave_referencia}
                              {ord.estatus === "Validada SGI" ? (
                                <button
                                  onClick={(ev) =>
                                    this.handleReturnStatusOrder(ev, 5)
                                  }
                                  id={ord.id}
                                  title="Devolver a en espera"
                                  className="btn btn-sm btn-warning ml-1"
                                >
                                  <i id={ord.id} className="fas fa-undo"></i>
                                </button>
                              ) : null}
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCertificadosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_cer - 1 > 0) {
                            this.setCertificadosPage(
                              this.state.paginaActual_cer - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_cer} de{" "}
                          {this.state.paginas_cer}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_cer >=
                            this.state.paginaActual_cer + 1
                          ) {
                            this.setCertificadosPage(
                              this.state.paginaActual_cer + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCertificadosPage(this.state.paginas_cer);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setCertificadosPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_cer}
                      value={this.state.paginaActual_cer}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="6">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaPreCertificado"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Servicio</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Cantidad</th>
                      <th className="text-center">Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.ordenes_pre.length > 0 ? (
                      this.state.ordenes_pre.map((ord) => (
                        <tr key={ord.id}>
                          <td className="text-center">{ord.folio_orden}</td>
                          <td className="text-center">{ord.nombre_cliente}</td>
                          <td className="text-center">{ord.nombre_servicio}</td>
                          <td className="text-center">
                            {format(new Date(ord.fecha_orden), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">{ord.cantidad_num}</td>
                          <td className="text-center">{ord.estatus}</td>

                          {ord.estatus !== null &&
                          ord.estatus !== "Validada SGI" &&
                          ord.estatus !== "En espera de documentación" ? (
                            <td className="text-center">
                              <button
                                onClick={this.handleOpenPago_Pre}
                                id={ord.id}
                                className="btn bg-gradient-green"
                              >
                                <i
                                  id={ord.id}
                                  className="fas fa-money-check-alt"
                                ></i>
                              </button>
                            </td>
                          ) : (
                            <td className="text-center">
                              Referencia: {ord.clave_referencia}
                              {ord.estatus === "Validada SGI" ? (
                                <button
                                  onClick={(ev) =>
                                    this.handleReturnStatusOrder(ev, 6)
                                  }
                                  id={ord.id}
                                  title="Devolver a en espera"
                                  className="btn btn-sm btn-warning ml-1"
                                >
                                  <i id={ord.id} className="fas fa-undo"></i>
                                </button>
                              ) : null}
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setPreCertificadosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_pre - 1 > 0) {
                            this.setPreCertificadosPage(
                              this.state.paginaActual_pre - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_pre} de{" "}
                          {this.state.paginas_pre}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_pre >=
                            this.state.paginaActual_pre + 1
                          ) {
                            this.setPreCertificadosPage(
                              this.state.paginaActual_pre + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setPreCertificadosPage(this.state.paginas_pre);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setPreCertificadosPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_pre}
                      value={this.state.paginaActual_pre}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </div>
        <Modal isOpen={this.state.modalRegente} modalClassName="modal-message">
          <ModalHeader toggle={() => this.setState({ modalRegente: false })}>
            Folio de solicitud:{" "}
          </ModalHeader>
          <ModalBody>
            <div className={this.state.working ? "" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>

            <div className={this.state.working ? "hide" : ""}>
              <div className="row"></div>

              <div className="btn-group pull-right">
                <button
                  className="btn btn-white"
                  onClick={() => this.setState({ modalRegente: false })}
                >
                  Regresar
                </button>
                <button value="4" className="btn btn-danger ">
                  Rechazar
                </button>
                <button value="5" className="btn btn-success">
                  Aceptar
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <PayOrders auth={auth} history={history} {...props} />;
};
